import { NewDate } from '@/Domain/News'
import { Currency } from '@/Domain/Batch/Currency'
import { OfferTarget } from '@/Domain/Offer'
import { HeavyTicket } from '@/Domain/Expediente'

export class HeavyTicketDto {
    private _especie: string
    private _forma: number
    private _destinoMadeira: OfferTarget
    private _numMatricula: string
    private _dataPesada: NewDate | null
    private _peso: Currency
    private _custoTotalTicket: Currency

    static fromHeavyTicket (heavy: HeavyTicket): HeavyTicketDto {
      return new HeavyTicketDto(
        heavy.especie,
        heavy.forma,
        heavy.destinoMadeiraTarget,
        heavy.numMatricula,
        heavy.dataPesada ? new NewDate(heavy.dataPesada) : null,
        heavy.peso,
        heavy.custoTotalTicket
      )
    }

    constructor (
      especie: string,
      forma: number,
      destinoMadeira: OfferTarget,
      numMatricula: string,
      dataPesada: NewDate | null,
      peso: Currency,
      custoTotalTicket: Currency
    ) {
      this._especie = especie
      this._forma = forma
      this._destinoMadeira = destinoMadeira
      this._numMatricula = numMatricula
      this._dataPesada = dataPesada
      this._peso = peso
      this._custoTotalTicket = custoTotalTicket
    }

    get especie (): string {
      return this._especie
    }

    get forma (): number {
      return this._forma
    }

    get destinoMadeiraTarget (): OfferTarget {
      return this._destinoMadeira
    }

    get destinoMadeira (): string {
      return this._destinoMadeira.toString()
    }

    get numMatricula (): string {
      return this._numMatricula
    }

    get dataPesada (): string {
      if (this._dataPesada !== null) {
        return this._dataPesada.date()
      } else { return '' }
    }

    get peso (): Currency {
      return this._peso
    }

    get custoTotalTicket (): Currency {
      return this._custoTotalTicket
    }
}
